@if (mode === 'token') {
  <main>
    <h1>{{ 'content.reset-password' | translate }}</h1>
    <p>{{ 'content.choose-new-password' | translate }}</p>
    <ng-container *ngTemplateOutlet='resetPasswordContent'></ng-container>
  </main>
} @else {
  <form [formGroup]="f" [ngClass]="{'form-submitted': formSubmitted}" (submit)="submit(f.value)">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        @if (mode === 'normal') {
          <div class="row">
            <div class="form-group col-12">
              <label>{{ 'content.current-password' | translate }} *
                <input class="form-control" type="password" autocomplete="on" formControlName="currentPassword" #currentPasswordInput>
              </label>
              <app-validation-errors [displayErrors]="formSubmitted" [errors]="c.currentPassword.errors" [element]="currentPasswordInput"></app-validation-errors>
            </div>
          </div>
        }
        <div class="form-row">
          <div class="form-group col-12">
            <label>{{ 'content.new-password' | translate }} *
              <input class="form-control" type="password" autocomplete="on" formControlName="newPassword" (ngModelChange)="c.newPasswordConfirm.updateValueAndValidity()" #newPasswordInput>
            </label>
            <app-validation-errors [displayErrors]="formSubmitted" [errors]="c.newPassword.errors" [element]="newPasswordInput"></app-validation-errors>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-12">
            <label>{{ 'content.new-password-confirm' | translate }} *
              <input class="form-control" type="password" autocomplete="on" formControlName="newPasswordConfirm" #newPasswordConfirmInput>
            </label>
            <app-validation-errors [displayErrors]="formSubmitted" [errors]="c.newPasswordConfirm.errors" [element]="newPasswordConfirmInput"></app-validation-errors>
          </div>
        </div>
        <div class="d-flex justify-content-end inline-gap-5 submit-buttons">
          <button class="tu-button primary tu-shadow" type="submit" [disabled]="!saveEnabled">{{ 'content.save' | translate }}</button>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 d-flex align-items-center">
        <div class="ps-4">
          <div>
            <p id="password-req-length">{{ 'content.password-rule-length' | translate }}</p>
            <p>{{ 'content.password-rule-must-contain' | translate }}:</p>
            <ul>
              <li id="password-req-alpha-lc">{{ 'content.password-rule-alpha-lc' | translate }}</li>
              <li id="password-req-alpha-uc">{{ 'content.password-rule-alpha-uc' | translate }}</li>
              <li id="password-req-num">{{ 'content.password-rule-num' | translate }}</li>
              <li id="password-req-special">{{ 'content.password-rule-special' | translate }}</li>
            </ul>
            <p>{{ 'content.password-rule-must-not-contain' | translate }}:</p>
            <ul>
              <li>{{ 'content.password-rule-no-sequence' | translate }}</li>
              <li>{{ 'content.password-rule-no-previous-five-passwords' | translate }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </form>
}
<ng-template #resetPasswordContent>
  <form [formGroup]="f" [ngClass]="{'form-submitted': formSubmitted}" (submit)="submit(f.value)">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        @if (mode === 'normal') {
          <div class="row">
            <div class="form-group col-12">
              <label>{{ 'content.current-password' | translate }} *
                <input class="form-control" type="password" autocomplete="on" formControlName="currentPassword" #currentPasswordInput>
              </label>
              <app-validation-errors [displayErrors]="formSubmitted" [errors]="c.currentPassword.errors" [element]="currentPasswordInput"></app-validation-errors>
            </div>
          </div>
        }
        <div class="form-row">
          <div class="form-group col-12">
            <label>{{ 'content.new-password' | translate }} *
              <input class="form-control" type="password" autocomplete="on" formControlName="newPassword" (ngModelChange)="c.newPasswordConfirm.updateValueAndValidity()" #newPasswordInput>
            </label>
            <app-validation-errors [displayErrors]="formSubmitted" [errors]="c.newPassword.errors" [element]="newPasswordInput"></app-validation-errors>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-12">
            <label>{{ 'content.new-password-confirm' | translate }} *
              <input class="form-control" type="password" autocomplete="on" formControlName="newPasswordConfirm" #newPasswordConfirmInput>
            </label>
            <app-validation-errors [displayErrors]="formSubmitted" [errors]="c.newPasswordConfirm.errors" [element]="newPasswordConfirmInput"></app-validation-errors>
          </div>
        </div>
        <div class="d-flex justify-content-end inline-gap-5 submit-buttons">
          <button class="tu-button primary tu-shadow" type="submit" [disabled]="!saveEnabled">{{ 'content.save' | translate }}</button>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 d-flex align-items-center">
        <div class="ps-4">
          <div>
            <p id="password-req-length">{{ 'content.password-rule-length' | translate }}</p>
            <p>{{ 'content.password-rule-must-contain' | translate }}:</p>
            <ul>
              <li id="password-req-alpha-lc">{{ 'content.password-rule-alpha-lc' | translate }}</li>
              <li id="password-req-alpha-uc">{{ 'content.password-rule-alpha-uc' | translate }}</li>
              <li id="password-req-num">{{ 'content.password-rule-num' | translate }}</li>
              <li id="password-req-special">{{ 'content.password-rule-special' | translate }}</li>
            </ul>
            <p>{{ 'content.password-rule-must-not-contain' | translate }}:</p>
            <ul>
              <li>{{ 'content.password-rule-no-sequence' | translate }}</li>
              <li>{{ 'content.password-rule-no-previous-five-passwords' | translate }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>
